class HowToUseTabs extends HTMLElement {
  constructor() {
    super();
    this._tabs = null;
    this._panels = null;
    this._isAnimating = false;

    if (Shopify && Shopify.designMode) {
      this.addEventListener('shopify:block:select', (event) => {
        const blockId = event.detail?.blockId || event.target.closest('[data-block-id]')?.dataset.blockId;
        if (blockId) this.setTab(blockId);
      });
    }
  }

  get tabs() {
    return this._tabs || Array.from(this.querySelectorAll('.htut__nav-card'));
  }

  get panels() {
    return this._panels || Array.from(this.querySelectorAll('.htut__panel'));
  }

  connectedCallback() {
    setTimeout(() => this.init(), 10);
  }

  init() {
    this._tabs = Array.from(this.querySelectorAll('.htut__nav-card'));
    this._panels = Array.from(this.querySelectorAll('.htut__panel'));

    if (!this._tabs.length) return;

    this._tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const blockId = tab.dataset.blockId;
        if (blockId && !tab.classList.contains('active')) {
          this.setTab(blockId);
        }
      });

      tab.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const blockId = tab.dataset.blockId;
          if (blockId && !tab.classList.contains('active')) {
            this.setTab(blockId);
          }
        }
      });
    });

    const index = new URLSearchParams(window.location.search).get('index');
    const tabIndex = index !== null ? parseInt(index, 10) : 0;
    const initialTab = this._tabs[tabIndex] || this._tabs[0];
    if (initialTab) this.setTab(initialTab.dataset.blockId, false);
  }

  setTab(blockId, animate = true) {
    if (this._isAnimating) return;

    const newPanel = this.panels.find((p) => p.dataset.blockId === blockId);
    const oldPanel = this.panels.find((p) => p.classList.contains('active'));

    if (!newPanel) return;

    // Update tab cards
    this.tabs.forEach((t) => {
      const isActive = t.dataset.blockId === blockId;
      t.classList.toggle('active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    if (oldPanel === newPanel) return;

    if (animate && typeof Motion !== 'undefined' && oldPanel) {
      this._isAnimating = true;
      Motion.animate(oldPanel, { opacity: [1, 0], y: [0, 12] }, { duration: 0.18 }).finished.then(() => {
        oldPanel.classList.remove('active');
        oldPanel.classList.add('hidden');
        newPanel.classList.add('active');
        newPanel.classList.remove('hidden');
        Motion.animate(newPanel, { opacity: [0, 1], y: [12, 0] }, { duration: 0.22 });
        this._isAnimating = false;
      });
    } else {
      this.panels.forEach((p) => {
        p.classList.remove('active');
        p.classList.add('hidden');
      });
      newPanel.classList.add('active');
      newPanel.classList.remove('hidden');
    }
  }

  disconnectedCallback() {
    if (this._tabs) {
      this._tabs.forEach((tab) => tab.replaceWith(tab.cloneNode(true)));
    }
  }
}

if (!customElements.get('how-to-use-tabs')) {
  customElements.define('how-to-use-tabs', HowToUseTabs);
}
